import { FunctionComponent, useEffect, useState } from 'react'
import UserRepository from 'modules/user/infra/repositories/UserRepository'
import { useOnboardContext } from 'modules/onboarding/context'

import {
  Container,
  Header,
  Action,
  Button,
  Main,
  Typography,
  Refresh,
  Error,
  WaveVariantE,
} from './styles'

import { SingleInputBoxes } from 'shared/components/InputBox/SingleInputBoxes'
import { steps } from 'modules/onboarding'

type TProps = {
  setSelectedStep?(step: number): void
}

const userRepository = new UserRepository()

const PIN: FunctionComponent<TProps> = ({ setSelectedStep }) => {
  const {
    state: { email },
  } = useOnboardContext()

  const [pin, setPin] = useState('')
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [loading, setLoading] = useState(false)

  const handleClearInput = () => {
    const inputs = document.querySelectorAll('input')
    inputs.forEach(i => {
      i.value = ''
    })
  }

  const sendPin = async () => {
    try {
      await userRepository.validateEmail(email)
    } catch (err) {
      setError(true)
      setErrorMessage(err.message)
    }
  }

  const onSubmitHandle = async (e: React.FormEvent) => {
    e.preventDefault()
    if (pin.length < 6) {
      return
    }
    try {
      await userRepository.validateEmailCode(email, pin)
      setSelectedStep(steps.SMS)
    } catch (err) {
      setError(true)
      setErrorMessage(err?.message)
      handleClearInput()
    }
  }

  const reSendPin = async () => {
    setLoading(true)
    try {
      await userRepository.validateEmail(email)
      setErrorMessage('')
      setError(false)
    } catch (err) {
      setErrorMessage(err?.message)
      setError(true)
    }
    setLoading(false)
  }

  useEffect(() => {
    sendPin()
  }, [email])

  return (
    <Container>
      <Header />
      <Main>
        <Typography variant="p1" fontWeight="semibold">
          Para continuar digite o PIN enviado em seu e-mail para continuar o
          cadastro.
        </Typography>
        <form autoComplete="off" id="pinForm" onSubmit={onSubmitHandle}>
          <SingleInputBoxes
            type="text"
            amount={6}
            onChangeValueInputBox={setPin}
          />
        </form>
        {error && <Error>{errorMessage}</Error>}
        {error && !loading && (
          <Button
            disabled={loading}
            variant="text"
            type="button"
            onClick={reSendPin}
          >
            <Refresh />
            Reenviar PIN por e-mail
          </Button>
        )}
        {loading && <WaveVariantE />}
      </Main>
      <Action>
        <Button
          type="button"
          variant="contained"
          size="lg"
          onClick={() => setSelectedStep(steps.UploadDoc)}
        >
          Voltar
        </Button>
        <Button
          disabled={pin.length < 6}
          type="submit"
          variant="contained"
          size="lg"
          form="pinForm"
        >
          Próximo
        </Button>
      </Action>
    </Container>
  )
}

export default PIN
